"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _stylesModule = _interopRequireDefault(require("@components/Form/FormBase/styles.module.scss"));

var _FormBase = _interopRequireDefault(require("@components/Form/FormBase"));

var _scss = require("@scss");

var _excluded = ["className", "classes", "name", "label", "placeholder", "value", "defaultValue", "error", "success", "size", "disabled", "options"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var className = _ref.className,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      label = _ref.label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      error = _ref.error,
      success = _ref.success,
      size = _ref.size,
      disabled = _ref.disabled,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded);

  var ref = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(externalRef, function () {
    return _objectSpread(_objectSpread({}, ref && ref.current ? {
      elementRef: ref.current
    } : {}), {}, {
      changeValue: function changeValue(value) {
        if (ref !== null && ref !== void 0 && ref.current) {
          var indexToSelect = _toConsumableArray(ref.current.options).findIndex(function (option) {
            return option.value === value;
          });

          if (indexToSelect > -1) {
            ref.current.selectedIndex = indexToSelect;

            if (props.onChange) {
              props.onChange({
                target: {
                  value: value
                }
              });
            }
          }
        }
      }
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_FormBase["default"], {
    name: name,
    label: label,
    error: error,
    success: success,
    classes: classes
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    ref: ref,
    id: name,
    name: name,
    "aria-label": label ? label : placeholder ? placeholder : ''
  }, value && {
    value: value
  }, defaultValue && {
    defaultValue: defaultValue
  }, disabled && {
    disabled: disabled
  }, {
    className: (0, _scss.cls)('custom-select', _stylesModule["default"]['custom-select'], size && _stylesModule["default"]["custom-select-".concat(size)], error && _stylesModule["default"]['is-invalid'], success && _stylesModule["default"]['is-valid'], className)
  }, props), placeholder ? /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    hidden: props === null || props === void 0 ? void 0 : props.required
  }, placeholder) : null, options ? options && Array.isArray(options) ? options.map(function (value, k) {
    return /*#__PURE__*/_react["default"].createElement("option", _extends({
      key: k,
      value: value
    }, value === null && {
      disabled: true
    }), value === null ? '--------' : value);
  }) : Object.keys(options).map(function (value, k) {
    return /*#__PURE__*/_react["default"].createElement("option", _extends({
      key: k,
      value: value
    }, options[value] === null && {
      disabled: true
    }), options[value] === null ? '--------' : options[value]);
  }) : null));
});
var _default = Select;
exports["default"] = _default;